import React from 'react'
import { Router, Redirect, Link } from '@reach/router'

const Segments = () => {
  return (
    <div className="segments">
      <h1>Segments</h1>
    </div>
  )
}

export default Segments
